import { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { DataTable, DataTablePagination } from 'components/common'
import { useQuery } from 'hooks'
import { fetchSapLogs } from 'utils/api/logsApi'
import { calculateOffset } from 'utils/helpers/pagination'
import { getColumns } from './utils'
import { filterEmptyValues } from 'utils/helpers'

const SapLogTable = () => {
  const [logResponse, setLogResponse] = useState<any>({})
  const [page, setPage] = useState<number>(0)

  const { search } = useLocation()
  const { getAllQueries } = useQuery()

  const columns = useMemo(() => getColumns(page), [page])

  // To get ERP Log data
  const getLogs = async () => {
    try {
      const { limit, page, sapLogFilters } = getAllQueries()

      // removing empty values and keys
      const filters = filterEmptyValues(sapLogFilters)

      const { data } = await fetchSapLogs({
        limit: limit || 10,
        page: page || 1,
        filters,
      })
      setPage(calculateOffset(data))
      setLogResponse(data)
    } catch (error) {
      setLogResponse({ docs: [] })
    }
  }

  useEffect(() => {
    getLogs()
  }, [search])

  return (
    <>
      <DataTable columns={columns} rows={logResponse?.docs} identifier="_id" />

      {/* Table Pagination */}
      <DataTablePagination
        currentPage={logResponse?.page}
        totalPages={logResponse?.totalPages}
        hasNextPage={logResponse?.hasNextPage}
        hasPrevPage={logResponse?.hasPrevPage}
        limit={logResponse?.limit}
        nextPage={logResponse?.nextPage}
        prevPage={logResponse?.prevPage}
      />
    </>
  )
}

export default SapLogTable
